import { RehypeDopplerHookInitializer } from './RehypeDopplerHookInitializer';

/** @deprecated Use RehypeDopplerHookInitializer instead. */
export const RehypeDopplerHook = RehypeDopplerHookInitializer;

/** @deprecated Use RehypeDopplerHookInitializer instead. */
export type RehypeDopplerHook = RehypeDopplerHookInitializer;
